// =============================================================================
// features/admin/feature-flags/UserSearchResults.tsx — Dropdown de resultados
// da busca de usuário (F32-S04). Extraído de UserAxisSelect por tamanho.
// =============================================================================

import * as React from 'react';

import type { UserResponse } from '../../../hooks/admin/useUsers.types';
import { cn } from '../../../lib/cn';

interface UserSearchResultsProps {
  searchReady: boolean;
  isLoading: boolean;
  results: UserResponse[];
  query: string;
  minQueryLength: number;
  onSelect: (id: string, fullName: string) => void;
}

export function UserSearchResults({
  searchReady,
  isLoading,
  results,
  query,
  minQueryLength,
  onSelect,
}: UserSearchResultsProps): React.JSX.Element {
  return (
    <div
      role="listbox"
      aria-label="Usuários encontrados"
      className="absolute top-full left-0 mt-1 w-full rounded-sm border border-border z-20 max-h-56 overflow-y-auto"
      style={{ background: 'var(--bg-elev-1)', boxShadow: 'var(--elev-3)' }}
    >
      {!searchReady ? (
        <p className="px-4 py-3 font-sans text-xs text-ink-4 italic">
          Digite ao menos {minQueryLength} caracteres para buscar.
        </p>
      ) : isLoading ? (
        <p className="px-4 py-3 font-sans text-xs text-ink-3">Buscando…</p>
      ) : results.length === 0 ? (
        <p className="px-4 py-3 font-sans text-xs text-ink-4 italic">
          Nenhum usuário ativo encontrado para &quot;{query}&quot;.
        </p>
      ) : (
        results.map((u) => (
          <button
            key={u.id}
            type="button"
            role="option"
            aria-selected={false}
            onClick={() => onSelect(u.id, u.fullName)}
            className={cn(
              'flex flex-col w-full px-4 py-2.5 text-left',
              'hover:bg-surface-hover transition-colors duration-fast',
              'focus-visible:outline-none focus-visible:bg-surface-hover',
            )}
          >
            <span className="font-sans text-sm text-ink">{u.fullName}</span>
            <span className="font-sans text-xs text-ink-4">{u.email}</span>
          </button>
        ))
      )}
    </div>
  );
}
